export default "__VITE_ASSET__Dmvf0g88__"